import type {
  BuildQuestionnaireRequest,
  GetThoughtsRequest,
  MindstringPrototype,
} from "@/generated/fastapi";

export const thoughtKeys = {
  all: ["thoughts"] as const,
  list: (request: GetThoughtsRequest) =>
    [...thoughtKeys.all, "list", request] as const,
  questionnaire: (
    request: BuildQuestionnaireRequest,
    refreshKey: number = 0,
  ) => [...thoughtKeys.all, "questionnaire", request, refreshKey] as const,
  suggestedReview: ({
    originId,
    languageFilters,
    limit,
    prototype,
    queryText,
    refreshKey = 0,
    semanticRatio,
    situationId,
    sortBy,
  }: {
    originId?: string | null;
    languageFilters?: string[] | null;
    limit?: number | null;
    prototype: MindstringPrototype;
    queryText?: string | null;
    refreshKey?: number;
    semanticRatio?: number | null;
    situationId?: string | null;
    sortBy?: string | null;
  }) =>
    [
      ...thoughtKeys.all,
      "suggested-review",
      {
        originId: originId ?? null,
        languageFilters: languageFilters ?? [],
        limit: limit ?? null,
        prototype,
        queryText: queryText?.trim() || null,
        refreshKey,
        semanticRatio: semanticRatio ?? null,
        situationId: situationId ?? null,
        sortBy: sortBy ?? null,
      },
    ] as const,
  traceOrigin: (originId?: string | null) =>
    [...thoughtKeys.all, "trace-origin", originId ?? null] as const,
};
